import { ChevronRightIcon } from "lucide-react";
import {
  type BreadcrumbProps,
  type BreadcrumbsProps,
  type LinkProps,
  Breadcrumb as RACBreadcrumb,
  Breadcrumbs as RACBreadcrumbs,
} from "react-aria-components";

import { Link } from "@/components/ui/link";
import { cn } from "@/components/ui/utils";

export function Breadcrumbs<T extends object>({
  className,
  ...props
}: BreadcrumbsProps<T>) {
  return (
    <RACBreadcrumbs
      {...props}
      className={cn(
        "flex gap-1 min-w-0",
        "[&>:last-child>span]:truncate [&>:last-child]:overflow-hidden",
        className,
      )}
    />
  );
}

export function Breadcrumb({
  className,
  ...props
}: BreadcrumbProps & LinkProps) {
  return (
    <RACBreadcrumb
      {...props}
      className={cn("flex items-center gap-1", className)}
    >
      <Link
        href={props.href}
        {...props}
        className="text-nowrap text-xs font-medium"
      />
      {"href" in props && props.href && (
        <ChevronRightIcon className="size-3 shrink-0 text-muted-foreground" />
      )}
    </RACBreadcrumb>
  );
}
